module.exports = __webpack_public_path__ + "img/logo-light.7026fbf8.svg";